import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "head" }
const _hoisted_2 = { id: "modal-title" }
const _hoisted_3 = { class: "buttons" }

import { ref, useTemplateRef, computed, onBeforeUnmount, onMounted, defineAsyncComponent } from 'vue';

import * as utils from '@services/utils/common';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'Modal',
},
  __name: 'Modal',
  props: {
    size: {},
    sidebar: {},
    canClose: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const NcModal = defineAsyncComponent(() => import('@nextcloud/vue/components/NcModal'));



const props = __props;

const emit = __emit;



const size = computed(() => props.size ?? 'small');
const sidebar = computed(() => props.sidebar ?? null);
const canClose = computed(() => props.canClose ?? true);

const modal = useTemplateRef<{ close?: () => void }>('modal');

const isSidebarShown = ref(false);
const sidebarWidth = ref(400);
const trapElements = ref<HTMLElement[]>([]);

if (sidebar.value) {
  utils.useBus('memories:sidebar:opened', handleAppSidebarOpen);
  utils.useBus('memories:sidebar:closed', handleAppSidebarClose);
}

onBeforeUnmount(() => {
  if (sidebar.value) {
    _m.sidebar.close();
  }
});

onMounted(() => {
  if (sidebar.value) {
    _m.sidebar.open(0, sidebar.value, true);

    // Adjust width anyway in case the sidebar is already open
    handleAppSidebarOpen();
  }
});

function close() {
  if (modal.value?.close) {
    modal.value.close();
  } else {
    // Premature calls, before the modal is mounted
    cleanup();
  }
}

function cleanup() {
  emit('close');
}

function handleAppSidebarOpen() {
  const sidebarEl = document.getElementById('app-sidebar-vue') ?? document.getElementById('app-sidebar-native');
  if (sidebarEl) {
    isSidebarShown.value = true;
    sidebarWidth.value = sidebarEl.offsetWidth;
    trapElements.value = [sidebarEl];
  }
}

function handleAppSidebarClose() {
  isSidebarShown.value = false;
  trapElements.value = [];
}

__expose({ close });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NcModal), {
    class: "memories-modal",
    ref_key: "modal",
    ref: modal,
    labelId: "modal-title",
    size: size.value,
    outTransition: true,
    style: _normalizeStyle({ width: isSidebarShown.value ? `calc(100% - ${sidebarWidth.value}px)` : null }),
    additionalTrapElements: trapElements.value,
    canClose: canClose.value,
    onClose: cleanup
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "container",
        onKeydown: _withModifiers(($event: any) => (0), ["stop"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, [
            _renderSlot(_ctx.$slots, "title")
          ])
        ]),
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "buttons")
        ])
      ], 32)
    ]),
    _: 3
  }, 8, ["size", "style", "additionalTrapElements", "canClose"]))
}
}

})